import {BaseCardNumberValidator} from './validator';

export {CardNumberDirective} from './directive';
export {CardNumberPipe} from './pipe';

export const CARD_NUMBER_VALIDATORS = [BaseCardNumberValidator];
